(function () {
  var VERIFIED_PROVIDER_URL = "https://www.smartcustomer.com/reviews/paintscratch.com";
  var INFINITE_LOADING_TEXT = "Loading more reviews...";
  var INFINITE_DONE_TEXT = "All reviews loaded.";
  var INFINITE_ERROR_TEXT = "Couldn't load more reviews. Use pagination links to continue.";
  var INFINITE_ROOT_MARGIN_BOTTOM = 520;
  var INFINITE_FOLLOWUP_DELAY_MS = 120;

  function addClass(el, className) {
    if (!el || !className) {
      return;
    }

    if (el.classList) {
      el.classList.add(className);
      return;
    }

    if ((" " + el.className + " ").indexOf(" " + className + " ") === -1) {
      el.className = el.className ? el.className + " " + className : className;
    }
  }

  function getText(el) {
    var text = "";

    if (!el) {
      return text;
    }

    text = el.textContent || el.innerText || "";
    return text.replace(/^\s+|\s+$/g, "");
  }

  function hasClass(el, className) {
    if (!el || !className) {
      return false;
    }

    if (el.classList) {
      return el.classList.contains(className);
    }

    return (" " + el.className + " ").indexOf(" " + className + " ") !== -1;
  }

  function removeClass(el, className) {
    if (!el || !className) {
      return;
    }

    if (el.classList) {
      el.classList.remove(className);
      return;
    }

    el.className = (" " + el.className + " ").replace(" " + className + " ", " ").replace(/^\s+|\s+$/g, "");
  }

  function ratingLooksBroken(ratingEl) {
    var full;
    var filled;
    var half;
    var empty;

    if (!ratingEl) {
      return false;
    }

    full = ratingEl.querySelectorAll(".ps-star--full");
    filled = ratingEl.querySelectorAll(".ps-star--filled");
    half = ratingEl.querySelectorAll(".ps-star--half");
    empty = ratingEl.querySelectorAll(".ps-star--empty");
    return !full.length && !filled.length && !half.length && !empty.length;
  }

  function normalizeRating(ratingEl, label) {
    if (!ratingEl || !ratingLooksBroken(ratingEl)) {
      return;
    }

    addClass(ratingEl, "is-ps-reviews-filled");

    if (label) {
      ratingEl.setAttribute("aria-label", label);
    }
  }

  function normalizeSummary(shell) {
    var summary;
    var valueEl;
    var ratingEl;
    var valueText;

    if (!shell || !shell.querySelector) {
      return;
    }

    summary = shell.querySelector(".ps-reviews-summary");
    if (!summary) {
      return;
    }

    valueEl = summary.querySelector(".ps-reviews-summary__value");
    ratingEl = summary.querySelector(".ps-star-rating");
    valueText = getText(valueEl);

    if ((valueText === "0" || valueText === "0.0" || valueText === "0.00") && ratingLooksBroken(ratingEl)) {
      addClass(valueEl, "ps-reviews-summary__value--fallback-hidden");
      normalizeRating(ratingEl, "Rated 5 out of 5");
    }
  }

  function enhanceVerifiedLink(shell) {
    var summary;
    var verifiedEl;
    var verifiedText;
    var verifiedLink;

    if (!shell || !shell.querySelector) {
      return;
    }

    summary = shell.querySelector(".ps-reviews-summary");
    if (!summary) {
      return;
    }

    verifiedEl = summary.querySelector(".ps-reviews-summary__verified");
    if (!verifiedEl || verifiedEl.querySelector("a")) {
      return;
    }

    verifiedText = getText(verifiedEl);
    if (!/^Reviews (?:Verified by|from)\s+smartcustomer$/i.test(verifiedText)) {
      return;
    }

    while (verifiedEl.firstChild) {
      verifiedEl.removeChild(verifiedEl.firstChild);
    }

    verifiedEl.appendChild(document.createTextNode("Reviews from "));

    verifiedLink = document.createElement("a");
    verifiedLink.href = VERIFIED_PROVIDER_URL;
    verifiedLink.appendChild(document.createTextNode("SmartCustomer"));
    verifiedEl.appendChild(verifiedLink);
  }

  function normalizeCards(shell) {
    var ratings;
    var i;

    if (!shell || !shell.querySelectorAll) {
      return;
    }

    ratings = shell.querySelectorAll(".ps-review-card .ps-star-rating");
    for (i = 0; i < ratings.length; i++) {
      normalizeRating(ratings[i], "Rated 5 out of 5");
    }
  }

  function initSortControl(shell) {
    var sortSelect;

    if (!shell || !shell.querySelector) {
      return;
    }

    sortSelect = shell.querySelector(".ps-reviews-sort-bar select");
    if (!sortSelect || sortSelect.getAttribute("data-ps-reviews-sort-bound") === "true") {
      return;
    }

    sortSelect.addEventListener("change", function () {
      var selectedValue;
      var nextUrl;

      selectedValue = sortSelect.value;
      if (!selectedValue) {
        return;
      }

      nextUrl = window.location.pathname + window.location.search;

      try {
        nextUrl = new URL(window.location.href);
        nextUrl.searchParams.set("sort", selectedValue);
        nextUrl.searchParams.delete("page");
        window.location.assign(nextUrl.toString());
        return;
      } catch (error) {
      }

      if (nextUrl.indexOf("?") === -1) {
        nextUrl = nextUrl + "?sort=" + encodeURIComponent(selectedValue);
      } else if (/[?&]sort=/.test(nextUrl)) {
        nextUrl = nextUrl.replace(/([?&])sort=[^&]*/g, "$1sort=" + encodeURIComponent(selectedValue));
      } else {
        nextUrl = nextUrl + "&sort=" + encodeURIComponent(selectedValue);
      }

      nextUrl = nextUrl.replace(/([?&])page=[^&]*&?/g, "$1");
      nextUrl = nextUrl.replace(/[?&]$/, "");
      window.location.assign(nextUrl);
    });

    sortSelect.setAttribute("data-ps-reviews-sort-bound", "true");
  }

  function observeSummary(shell) {
    var summary;
    var observer;

    if (!shell || !window.MutationObserver || shell.getAttribute("data-ps-reviews-summary-observer") === "true") {
      return;
    }

    summary = shell.querySelector(".ps-reviews-shell__summary");
    if (!summary) {
      return;
    }

    observer = new MutationObserver(function () {
      normalizeSummary(shell);
      enhanceVerifiedLink(shell);
    });

    observer.observe(summary, {
      childList: true,
      subtree: true
    });

    shell.setAttribute("data-ps-reviews-summary-observer", "true");
  }

  function getPageNumberFromUrl(url) {
    var match;

    if (!url) {
      return 0;
    }

    match = String(url).match(/[?&]page=(\d+)/i);
    if (!match || !match[1]) {
      return 0;
    }

    return parseInt(match[1], 10) || 0;
  }

  function getCurrentPage(pagination) {
    var currentEl;
    var currentText;
    var currentPage;

    if (!pagination || !pagination.querySelector) {
      return 1;
    }

    currentEl = pagination.querySelector(".is-current, [aria-current='page']");
    currentText = getText(currentEl);
    currentPage = parseInt(currentText, 10);

    if (!isNaN(currentPage) && currentPage > 0) {
      return currentPage;
    }

    currentPage = getPageNumberFromUrl(window.location.search);
    if (!currentPage) {
      currentPage = getPageNumberFromUrl(window.location.href);
    }

    return currentPage > 0 ? currentPage : 1;
  }

  function getNextPageHref(pagination, currentPage) {
    var links;
    var i;
    var href;
    var pageNum;
    var bestPage;
    var bestHref;

    if (!pagination || !pagination.querySelectorAll) {
      return "";
    }

    links = pagination.querySelectorAll("a[href]");
    bestPage = 0;
    bestHref = "";

    for (i = 0; i < links.length; i++) {
      href = links[i].getAttribute("href") || "";
      pageNum = getPageNumberFromUrl(href);

      if (!pageNum || pageNum <= currentPage) {
        continue;
      }

      if (!bestPage || pageNum < bestPage) {
        bestPage = pageNum;
        bestHref = href;
      }
    }

    return bestHref;
  }

  function toAbsoluteUrl(url) {
    var loc;
    var origin;

    if (!url) {
      return "";
    }

    try {
      return new URL(url, window.location.href).toString();
    } catch (error) {
    }

    if (/^https?:\/\//i.test(url)) {
      return url;
    }

    loc = window.location;
    origin = loc.origin || (loc.protocol + "//" + loc.host);
    if (url.charAt(0) === "/") {
      return origin + url;
    }

    return origin + "/" + url;
  }

  function getGridElement(root) {
    var gridWrapper;

    if (!root || !root.querySelector) {
      return null;
    }

    gridWrapper = root.querySelector("#ps-reviews-grid");
    if (!gridWrapper) {
      return null;
    }

    return gridWrapper.querySelector(".ps-reviews-grid") || gridWrapper;
  }

  function setInfiniteStatus(state, message) {
    if (!state || !state.statusEl) {
      return;
    }

    state.statusEl.textContent = message || "";
  }

  function shouldContinueLoading(state) {
    var rect;
    var viewportHeight;

    if (!state || !state.sentinel || !state.sentinel.getBoundingClientRect) {
      return false;
    }

    rect = state.sentinel.getBoundingClientRect();
    viewportHeight = window.innerHeight || (document.documentElement ? document.documentElement.clientHeight : 0) || 0;
    return rect.top <= viewportHeight + INFINITE_ROOT_MARGIN_BOTTOM;
  }

  function scheduleFollowupLoad(shell, state) {
    if (!state || state.followupTimer) {
      return;
    }

    state.followupTimer = window.setTimeout(function () {
      state.followupTimer = null;

      if (!state.hasNext || state.isLoading) {
        return;
      }

      if (shouldContinueLoading(state)) {
        fetchNextPage(shell, state);
      }
    }, INFINITE_FOLLOWUP_DELAY_MS);
  }

  function stopInfiniteScroll(shell, state, message, showPaginationFallback) {
    if (!state) {
      return;
    }

    state.hasNext = false;
    state.nextUrl = "";

    if (state.observer && state.observer.disconnect) {
      state.observer.disconnect();
    }

    if (state.followupTimer) {
      window.clearTimeout(state.followupTimer);
      state.followupTimer = null;
    }

    if (showPaginationFallback) {
      removeClass(shell, "is-ps-reviews-infinite-enabled");
    }

    setInfiniteStatus(state, message);
  }

  function syncInfiniteState(shell, state) {
    var nextHref;

    if (!state) {
      return;
    }

    state.pagination = shell.querySelector("#ps-reviews-pagination");
    state.currentPage = getCurrentPage(state.pagination);
    nextHref = getNextPageHref(state.pagination, state.currentPage);
    state.nextUrl = toAbsoluteUrl(nextHref);
    state.hasNext = !!state.nextUrl;

    if (!state.hasNext) {
      stopInfiniteScroll(shell, state, INFINITE_DONE_TEXT, false);
    } else {
      setInfiniteStatus(state, "");
    }
  }

  function appendCards(shell, state, nextDoc) {
    var nextGrid;
    var nextCards;
    var nextPagination;
    var i;
    var card;

    if (!state || !nextDoc) {
      return false;
    }

    nextGrid = getGridElement(nextDoc);
    if (!nextGrid || !state.grid) {
      return false;
    }

    nextCards = nextGrid.querySelectorAll(".ps-review-card");
    if (!nextCards || !nextCards.length) {
      return false;
    }

    for (i = 0; i < nextCards.length; i++) {
      card = nextCards[i].cloneNode(true);
      state.grid.appendChild(card);
    }

    nextPagination = nextDoc.querySelector("#ps-reviews-pagination");
    if (state.pagination && nextPagination) {
      state.pagination.innerHTML = nextPagination.innerHTML;
    }

    normalizeCards(shell);
    return true;
  }

  function fetchNextPage(shell, state) {
    if (!state || state.isLoading || !state.nextUrl) {
      return;
    }

    if (state.loadedUrls[state.nextUrl]) {
      stopInfiniteScroll(shell, state, INFINITE_DONE_TEXT, false);
      return;
    }

    state.isLoading = true;
    setInfiniteStatus(state, INFINITE_LOADING_TEXT);

    fetch(state.nextUrl, {
      credentials: "same-origin",
      cache: "no-store"
    }).then(function (response) {
      if (!response || !response.ok) {
        throw new Error("Request failed");
      }

      return response.text();
    }).then(function (html) {
      var parser;
      var nextDoc;
      var appended;

      parser = new DOMParser();
      nextDoc = parser.parseFromString(html, "text/html");
      appended = appendCards(shell, state, nextDoc);

      if (!appended) {
        throw new Error("No reviews appended");
      }

      state.loadedUrls[state.nextUrl] = true;
      syncInfiniteState(shell, state);
    }).catch(function () {
      stopInfiniteScroll(shell, state, INFINITE_ERROR_TEXT, true);
    }).then(function () {
      state.isLoading = false;
      scheduleFollowupLoad(shell, state);
    });
  }

  function ensureInfiniteElements(shell, state) {
    var container;
    var paginationWrap;

    if (!shell || !state) {
      return;
    }

    container = shell.querySelector(".ps-reviews-shell__container") || shell;
    paginationWrap = shell.querySelector("#ps-reviews-pagination");

    state.statusEl = shell.querySelector(".ps-reviews-shell__infinite-status");
    if (!state.statusEl) {
      state.statusEl = document.createElement("p");
      state.statusEl.className = "ps-reviews-shell__infinite-status";
      state.statusEl.setAttribute("aria-live", "polite");
      state.statusEl.setAttribute("aria-atomic", "true");
      container.appendChild(state.statusEl);
    }

    state.sentinel = shell.querySelector(".ps-reviews-infinite-sentinel");
    if (!state.sentinel) {
      state.sentinel = document.createElement("div");
      state.sentinel.className = "ps-reviews-infinite-sentinel";
      state.sentinel.setAttribute("aria-hidden", "true");
      if (paginationWrap && paginationWrap.parentNode) {
        paginationWrap.parentNode.insertBefore(state.sentinel, paginationWrap);
      } else {
        container.appendChild(state.sentinel);
      }
    }
  }

  function initInfiniteScroll(shell) {
    var state;

    if (!shell || !shell.querySelector || shell.getAttribute("data-ps-reviews-infinite-bound") === "true") {
      return;
    }

    if (!window.fetch || !window.IntersectionObserver || !window.DOMParser) {
      return;
    }

    state = {
      isLoading: false,
      hasNext: false,
      currentPage: 1,
      nextUrl: "",
      loadedUrls: {},
      observer: null,
      followupTimer: null,
      grid: getGridElement(shell),
      pagination: shell.querySelector("#ps-reviews-pagination"),
      sentinel: null,
      statusEl: null
    };

    if (!state.grid || !state.pagination) {
      return;
    }

    ensureInfiniteElements(shell, state);
    syncInfiniteState(shell, state);

    if (!state.hasNext || !state.sentinel) {
      return;
    }

    addClass(shell, "is-ps-reviews-infinite-enabled");

    state.observer = new IntersectionObserver(function (entries) {
      var i;
      var entry;

      for (i = 0; i < entries.length; i++) {
        entry = entries[i];
        if (entry && entry.isIntersecting) {
          fetchNextPage(shell, state);
        }
      }
    }, {
      root: null,
      rootMargin: "0px 0px " + INFINITE_ROOT_MARGIN_BOTTOM + "px 0px",
      threshold: 0
    });

    state.observer.observe(state.sentinel);
    shell.setAttribute("data-ps-reviews-infinite-bound", "true");
  }

  function init(root) {
    var context;
    var shells;
    var i;
    var shell;

    context = root && root.querySelectorAll ? root : document;
    shells = context.querySelectorAll(".ps-reviews-shell--ssr");

    if (root && root.nodeType === 1 && hasClass(root, "ps-reviews-shell--ssr")) {
      normalizeSummary(root);
      normalizeCards(root);
      enhanceVerifiedLink(root);
      initSortControl(root);
      observeSummary(root);
      initInfiniteScroll(root);
    }

    for (i = 0; i < shells.length; i++) {
      shell = shells[i];
      normalizeSummary(shell);
      normalizeCards(shell);
      enhanceVerifiedLink(shell);
      initSortControl(shell);
      observeSummary(shell);
      initInfiniteScroll(shell);
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    init(event && event.target ? event.target : document);
  });

  document.addEventListener("shopify:section:reorder", function (event) {
    init(event && event.target ? event.target : document);
  });

  window.addEventListener("pageshow", function () {
    init(document);
  });
})();
